// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".call_back[data-v-2b2b5c80]{min-height:calc(var(--vh, 1vh)*100 - 203px);background-size:cover;background-position:50%;background-repeat:no-repeat}.call_back-card[data-v-2b2b5c80]{background-color:hsla(0,0%,100%,.9);padding:30px;text-align:center}.call_back-card_title[data-v-2b2b5c80]{font-weight:700;line-height:1.8}.call_back-card_title a[data-v-2b2b5c80]{color:#a3282e}", ""]);
// Exports
module.exports = exports;
